import {
  RESTAURANTS_LOADED,
  UPDATE_RESTAURANT_SUCCESS,
  UPDATE_RESTAURANT_ERROR,
  CREATE_RESTAURANT_SUCCESS,
  CREATE_RESTAURANT_ERROR,
  RESTAURANTS_LOADED_ERROR,
  NO_RESTAURANTS_ADDED,
  RESET_USER_GROUP_SELECTED,
  MENUS_LOADED,
  MENUS_SORTED,
} from "../actions/ActionTypes";
import { createDefaultRestaurant } from "../actions/Menu";

const initialState = {
  restaurant: createDefaultRestaurant(),
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESTAURANTS_LOADED: {
      return {
        restaurant: payload,
      };
    }

    case RESTAURANTS_LOADED_ERROR:
    case RESET_USER_GROUP_SELECTED:
    case NO_RESTAURANTS_ADDED: {
      return {
        restaurant: createDefaultRestaurant(),
      };
    }

    case UPDATE_RESTAURANT_SUCCESS: {
      return {
        restaurant: payload,
      };
    }

    case CREATE_RESTAURANT_SUCCESS: {
      return {
        restaurant: payload,
      };
    }

    case MENUS_LOADED: {
      return {
        restaurant: {
          ...state.restaurant,
          menusPosition: action.menusPosition,
        },
      };
    }

    case MENUS_SORTED: {
      return {
        restaurant: {
          ...state.restaurant,
          menusPosition: action.menusPosition,
        },
      };
    }

    case UPDATE_RESTAURANT_ERROR:
    case CREATE_RESTAURANT_ERROR: {
      return state;
    }

    default:
      return state;
  }
}
